import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';
import { isNullOrUndefined } from 'src/app/services/utils';
import { COMMON_CONSTANTS } from '../../common/core/common.constants';

@Pipe({
  name: 'serviceFilter',
  pure: false
})
export class ServiceFilterPipe implements PipeTransform {

  transform(serviceList: any, type: any): any {
    let filterList = [];
    type = !isNullOrUndefined(type)? type.toUpperCase():type;
    switch (type) {
      case COMMON_CONSTANTS.ALL_TYPES_SERVICE.BLOCKING_CAPS:
        filterList = _.filter(serviceList, (service) => {
          return service.category === COMMON_CONSTANTS.ALL_TYPES_SERVICE.BLK || service.group?.toUpperCase() === COMMON_CONSTANTS.ALL_TYPES_SERVICE.BLOCKING_CAPS;
        });
        break;
      case COMMON_CONSTANTS.ALL_TYPES_SERVICE.DATA_CAPS:
        filterList = _.filter(serviceList, (service) => {
          return service.group?.toUpperCase() === COMMON_CONSTANTS.ALL_TYPES_SERVICE.DATA_CAPS && (service.category !== COMMON_CONSTANTS.ALL_TYPES_SERVICE.BLK || service.category === null || service.category ==undefined );
        });
        break;
      case COMMON_CONSTANTS.ALL_TYPES_SERVICE.OTHER_CAPS:
        filterList = _.filter(serviceList, (service) => {
          return (service.group?.toUpperCase() === COMMON_CONSTANTS.ALL_TYPES_SERVICE.OTHER_CAPS && (service.category !== COMMON_CONSTANTS.ALL_TYPES_SERVICE.BLK || service.category === null || service.category === undefined) ||
          ((service.group == null || service.group == undefined) && service.category != COMMON_CONSTANTS.ALL_TYPES_SERVICE.BLK));
        });
        break;

    }
    return filterList;
  }

}
